import Vue from "vue";
import Component from "vue-class-component";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";
import { Prop } from "vue-property-decorator";

@Component({ name: "XtraOrdinaryTour" })
export default class XtraOrdinaryTour extends Vue {
    public localizer: any = Localizer;
    public isVisible: boolean = false;
    public isReady: boolean = false;
    
    @Prop() readonly language: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        let cookie = CookieHelper.getCookie("xot");
        let vm = this;
        if (!cookie && CookieHelper.isCookiePolicy()) {
            this.isVisible = true;

            setTimeout(() => {
                vm.isReady = true;
            }, 1000);
        }
    }

    public close() {
        CookieHelper.setCookie("xot", "xot", 30);
        GTagHelper.sendEvent("click", "XtraOrdinaryTour", "close");
        this.isVisible = false;
    }

    public openLink() {
        let vm = this;
        CookieHelper.setCookie("xot", "xot", 30);
        this.isReady = false;
        window.location.assign("/europe/" + this.language + "/xtraordinarytour2025");
        GTagHelper.sendEvent("click", "XtraOrdinaryTour", "banner");
    }
};